import { createFileRoute } from "@tanstack/react-router";
import AdmissionInquiryPage from "@project/user/pages/admission/admission-inquiry";

export const Route = createFileRoute("/_user/_admission/admission-inquiry")({
  head: () => ({
    meta: [
      { title: "Admission Inquiry — Jivandhara Vruddhashram" },
      {
        name: "description",
        content:
          "Submit an admission inquiry for an elderly person at our Vruddhashram. Share health, income and family details for our care team to review.",
      },
      { property: "og:title", content: "Admission Inquiry — Jivandhara" },
      {
        property: "og:description",
        content: "Submit an admission inquiry for the Vruddhashram.",
      },
    ],
  }),
  component: AdmissionInquiryPage,
});
